<script lang="ts">
  import Dialog from "./Dialog.svelte";
  import { onMount, type Snippet } from "svelte";
  import TaskLine from "./MatterCard/TaskLine.svelte";
  import { Task } from "../lib/tasks";
  import { CloseActions, type CloseActionType, type UnsignedMattersState } from "./LeadUnsigned/UnsignedMattersState.svelte";

  let {
    manager,
    openOnMount,
    afterClose = (action: CloseActionType) => {},
    children
  }: {
    manager: UnsignedMattersState,
    openOnMount: boolean,
    afterClose?: (CloseActionType) => void,
    children?: Snippet
  } = $props();

  let dialog = $state<Dialog>();

  const open = () => {
    manager.reset();
    dialog?.showModal();
    manager.recordOpenInteraction();
  };

  const reopen = (e: SubmitEvent) => {
    e?.preventDefault();
    open();
  };

  const onReady = () => {
    if (openOnMount) dialog?.showModal();
  }

  const onComplete = (afterCloseAction: CloseActionType) => {
    dialog?.close();
    afterClose(afterCloseAction);
  };

  manager.setActions({
    onComplete
  });

  onMount(() => manager.setup(onReady))
</script>

{#if manager.count}
  <TaskLine onsubmit={reopen} id={`lead-unsigned-${manager.matterType}`} task={new Task({
    path: "",
    icon: "sparkle",
    status: "optional",
    title: `We found ${(manager.count > 1) ? `more ${manager.matterType.toUpperCase()} claims` : `another ${manager.matterType.toUpperCase()} claim`} for you!`,
    button_label: "See details",
    ready: true
  })} />
{/if}

<Dialog bind:this={dialog} 
  autofocus
  onclose={() => { afterClose(manager.nextSignableMatterType ? CloseActions.CONTINUE_SIGNING : CloseActions.VIEW_SIGNED) }}
  showClose={manager.currentStep != manager.offerStep && !manager.mattersSigned.length}>

  {@render children()}
</Dialog>
